import { NgModule } from '@angular/core';
import { MomentModule } from 'ngx-moment';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { DirectivesModule } from '../../../components/directives.module';
import { InstantCheckupListModule } from './list';
import { InstantCheckupComponent } from './instant-checkup.component';

const ROUTES: Routes = [
  {
    path: '',
    component: InstantCheckupComponent,
    loadChildren: (): any => InstantCheckupListModule,
    pathMatch: 'full',
  },
];

@NgModule({ imports: [
  CommonModule,
  MomentModule,
  DirectivesModule,
  RouterModule.forChild(ROUTES),
],
declarations: [InstantCheckupComponent],
exports: [InstantCheckupComponent] })
export class InstantCheckupModule {}
